export default __webpack_public_path__ + "static/media/laptop-using-lg-1.f9735a7a.jpg";